import * as React from 'react';
import * as Spinner from 'react-spinkit';
    import styled from 'styled-components';
import Colours from '../State/Colours';
import Context from '../State/Context';
import devices from '../State/Devices';
import MainContentPanel from './MainContentPanel';
import ProgressPanel from './ProgressPanel';

const BaseLayout = styled.div`
    box-sizing: border-box;
    display: -ms-grid;
    display: grid;
    grid-template-columns: 380px 1fr;
    -ms-grid-columns: 380px 1fr;
    border: 2px solid ${Colours.gray};

    h2 {
        margin-top: 24px;
    }

    @media ${devices.laptop} {
        grid-template-columns: 1fr;
        -ms-grid-columns: 1fr;

        h2 {
            font-size: 1em;
        }
    }

    @media ${devices.print} {
        display: block;
        height: auto;

        .ProgressPanel,
        .PageNavigationFooter,
        .fa-edit {
            display: none;
        }
        
        .ContentPanel {
            overflow: visible;

            button {
                display: none;
            }

            .CollapsableSummaryList {
                display: -ms-grid;
                display: grid;
            }
        }
    }
`;

const LoadingContainer = styled.div`
    box-sizing: border-box;
    display: -ms-grid;
    display: grid;
    font-weight: bold;
    font-size: 22px;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 30px;
    -ms-grid-columns: 1fr;
    -ms-grid-rows; 1fr 30px;
    height: 400px;
    align-items: center;
    justify-items: center;

    .sk-spinner {
    }
`;

export default class App extends React.Component {
    public render() {
        return (
            <Context.Consumer>
                {({ loaded }) => (
                    <React.Fragment>
                        {!loaded && (
                            <LoadingContainer>
                                <Spinner name="ball-scale-ripple-multiple" fadeIn="half" color={Colours.primary} />
                                Loading...
                            </LoadingContainer>
                        )}
                        {loaded && (
                            <BaseLayout>
                                <ProgressPanel />
                                <MainContentPanel />
                            </BaseLayout>
                        )}
                    </React.Fragment>
                )}
            </Context.Consumer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Components/App.tsx